// Keep the existing server invalidation key as the content cache root.
export const CONTENT_QUERY_ROOT = "contents-filtered";
export const PUBLIC_CONTENT_QUERY_ROOT = "public-contents-filtered";
